import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/preferred-relationships/new/loading';

export const Route = createFileRoute('/_private/settings/preferred-relationships/new')({
  component: Loading,
});
